'use client';

import CommentForm from './CommentForm';
import CommentList from './CommentList';

export default function Comment({ locatedFor }: { locatedFor: 'post' | 'publication' }) {
  return (
    <div className="mt-8 space-y-2">
      <CommentList locatedFor={locatedFor} />
      <CommentForm locatedFor={locatedFor} />
    </div>
  );
}
